module.exports = __webpack_public_path__ + "img/MES9Indice3_cutout.fdb108b6.png";